import React, {useContext, useEffect, useState} from "react";
import Dropdown from "react-dropdown";
import OutsideClickHandler from 'react-outside-click-handler';
import {store} from "../../Store/store";

export default function ConfirmationHistoryDropdownEditor({
                                                              options,
                                                              value,
                                                              row,
                                                              updateExcludedCheckBoxArr,
                                                              handleOnEdit,
                                                              getConfirmationEnum,
                                                              onUpdate
                                                          }) {
    const [isEditing, setIsEditing] = useState(true);
    const stateObj = useContext(store);
    const isRequestInProgress = stateObj.state.isRequestInProgress;
    const isExcludedCheckboxDisabledArr = stateObj.state.isExcludedCheckboxDisabledArr;
    const dropDownDisabled = isRequestInProgress.state && isRequestInProgress.rowId === row.id;

    const getConfirmationValue = () => {
        const result = options.filter(option => {
            let one = option.value.toString();
            let two = value.toString();
            return one === two;
        })
        return result;
    }

    const currentValue = getConfirmationValue()

    const updateCheckboxArrObj = (state, isFalseAlert) => {
        const newArr = isExcludedCheckboxDisabledArr.map(obj => {
            if (obj.id === row.id) {
                const result = isFalseAlert === null ? {...obj, state: state} : {
                    ...obj, state: state, isFalseAlert: isFalseAlert
                }
                return result;
            }
            return obj;
        })
        updateExcludedCheckBoxArr(newArr);
    }

    useEffect(() => {
        if (isEditing) {
            handleOnEdit(true);
        }
    }, [isEditing])

    const finalizeEditing = (value) => {
        if (getConfirmationEnum(value) === 'CONFIRMED_FALSE_ALERT') {
            updateCheckboxArrObj(true, true);
        } else {
            updateCheckboxArrObj(false, false);
        }

        setIsEditing(false);
        handleOnEdit(false);
    }
    const handleChange = (e) => {
        finalizeEditing(e.value);
        onUpdate(e.value);
    };

    return (<OutsideClickHandler
        onOutsideClick={() => {
            finalizeEditing();
            onUpdate(currentValue[0].value);
        }}
    >
        <Dropdown controlClassName='dropDownControl' menuClassName='menuControl' value={currentValue[0].label} options={options}
                  disabled={dropDownDisabled}
                  onChange={handleChange}/>
    </OutsideClickHandler>)
}
